import 'bootstrap/dist/css/bootstrap.css'
import 'firebase/analytics'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'font-awesome/css/font-awesome.css'
// import css
import 'select2/dist/css/select2.css'
import 'sweetalert2/dist/sweetalert2.css'
import 'toastr/build/toastr.css'
import VTooltip from 'v-tooltip'
import Vue from 'vue'
import App from './App.vue'
import './assets/animate.css'
import './assets/styles/main.scss'
import i18n from './i18n'
import './lib/hopscotch/css/hopscotch.css'
import mask from './lib/mask'
import router from './router'
import store from './store'
import { setupVeeValidate } from './veeValidate'

window.$ = window.jQuery = require('jquery')

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBOMKP2LxuhWJOxJF_OomFQBe1_lAU7pB8',
  authDomain: 'portal-imea-test.firebaseapp.com',
  projectId: 'portal-imea-test',
  storageBucket: 'portal-imea-test.appspot.com',
  messagingSenderId: '296017333300',
  appId: '1:296017333300:web:298d28c7c557ebd7808e61',
  measurementId: 'G-TEJQ0RQXKK'
}

firebase.initializeApp(firebaseConfig)
firebase.analytics()
switch (process.env.VUE_APP_MODE) {
  case 'production':
    firebase.analytics().setAnalyticsCollectionEnabled(true)
    break
  case 'homolog':
    firebase.analytics().setAnalyticsCollectionEnabled(false)
    break
  default:
    firebase.analytics().setAnalyticsCollectionEnabled(false)
    break
}

Vue.prototype.$analytics = firebase.analytics()

// Setup validator
setupVeeValidate()
Vue.directive(mask.name, mask.directive)
Vue.config.keyCodes.tab = 9

Vue.use(VTooltip)

// Setup vue
Vue.config.productionTip = false

const root = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

root.$checkPermission = function(component, claim) {
  if (!claim) {
    claim = 'Visualizar'
  }
  if ((store.state.menu.info[component] || []).find(i => i === claim)) {
    return true
  } else {
    return false
  }
}

window.vue = root
